import { render, staticRenderFns } from "./featuresTraduction.vue?vue&type=template&id=89ecd570&"
import script from "./featuresTraduction.vue?vue&type=script&lang=js&"
export * from "./featuresTraduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports